"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("../constants");

var _getTransition = _interopRequireDefault(require("../getTransition"));

var _stopTransitionOnSideChange = _interopRequireDefault(require("../stopTransitionOnSideChange"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledOverlay = _styledComponents["default"].div.attrs({
  style: function style(_ref) {
    var side = _ref.side,
        verticalWipePercentage = _ref.verticalWipePercentage;
    return {
      transform: side === _constants.Sides.Right ? "translateX(".concat(verticalWipePercentage, "%)") : "translateX(-".concat(verticalWipePercentage, "%)")
    };
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: ", ";\n  ", ";\n"])), function (props) {
  return props.overlayColor;
}, _getTransition["default"]);

var Overlay = (0, _stopTransitionOnSideChange["default"])(StyledOverlay);
var _default = Overlay;
exports["default"] = _default;